export function tabs() {

    $(".tab").click(function() {
        $(".tab").removeClass("active").eq($(this).index()).addClass("active");
        $(".tab_item").hide().eq($(this).index()).show();
        $(".tab_item").eq($(this).index()).find('.tab-inner').first().trigger('click');
    }).eq(0).addClass("active");

    $(".tab.all").click(function() {
        $(".tab_item").show();
    });

    $(".tab-inner").click(function() {
        $(".tab-inner").removeClass("active");
        $(this).addClass("active");

        var index = $(this).attr('data-index');
        console.log(index);
        $(".tab_item-inner").hide();
        $('[data-tab = '+ index +']').show();
    }).eq(0).addClass("active");
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabs.js